/* Email sign-up popup: when it opens, the Klaviyo sign-up and the
   free-shipping code. Markup and settings: sections/sm-popup.liquid.
   Visitor state is kept in localStorage under "smPopup":
   { state: "subscribed" } never shows again; { state: "seen" | "closed", at }
   waits the number of days set in the section. Visitors Klaviyo already
   recognises (from an email link or an earlier sign-up) never see it. */
(function () {
  'use strict';

  var STORE = 'smPopup';
  var REVISION = '2026-07-15';
  var DAY = 864e5;
  var desktop = window.matchMedia('(min-width: 750px)');

  function load() {
    try { return JSON.parse(window.localStorage.getItem(STORE)) || {}; } catch (e) { return {}; }
  }
  function save(state) {
    try { window.localStorage.setItem(STORE, JSON.stringify(state)); } catch (e) { /* private mode */ }
  }

  var params = new URLSearchParams(window.location.search);
  var forced = params.get('sm_popup') === '1';
  // Visitors arriving from one of our emails are already on the list
  if (params.has('_kx') || (params.get('utm_source') || '').toLowerCase() === 'klaviyo' || params.get('utm_medium') === 'email') {
    if (load().state !== 'subscribed') save({ state: 'subscribed', at: Date.now() });
  }

  // Klaviyo's own script remembers visitors it has identified (from an email
  // link, a form or an earlier sign-up) in the __kla_id cookie.
  function klaviyoCookieKnows() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!match) return false;
      var data = JSON.parse(window.atob(decodeURIComponent(match[1])));
      return !!(data && (data.$exchange_id || data.$email));
    } catch (e) {
      return false;
    }
  }

  function klaviyoKnows(callback) {
    if (klaviyoCookieKnows()) return callback(true);
    var k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return callback(false);
    var settled = false;
    function finish(known) {
      if (settled) return;
      settled = true;
      callback(!!known);
    }
    window.setTimeout(function () { finish(false); }, 1500);
    try {
      Promise.resolve(k.isIdentified()).then(finish, function () { finish(false); });
    } catch (e) {
      finish(false);
    }
  }

  function init(root) {
    if (!root || root.dataset.smReady) return;
    root.dataset.smReady = '1';

    var panel = root.querySelector('.sm-popup__panel');
    var form = root.querySelector('[data-sm-popup-form]');
    var input = form.querySelector('input[type="email"]');
    var submit = form.querySelector('[type="submit"]');
    var error = form.querySelector('.sm-popup__error');
    var stepForm = root.querySelector('[data-step="form"]');
    var stepDone = root.querySelector('[data-step="done"]');
    var formTitle = stepForm.querySelector('.sm-popup__title');
    var doneTitle = stepDone.querySelector('.sm-popup__title');
    var copy = root.querySelector('[data-sm-popup-copy]');
    var code = root.querySelector('[data-sm-popup-code]');

    var key = root.dataset.key;
    var list = root.dataset.list;
    var delay = Number(root.dataset.delay) || 0;
    var scrollPct = Number(root.dataset.scroll) || 50;
    var days = Number(root.dataset.days) || 14;
    var design = root.hasAttribute('data-design-mode');

    var isOpen = false;
    var lastFocus = null;
    var timer = null;

    function isModal() { return desktop.matches; }

    function setModal() { panel.setAttribute('aria-modal', isModal() ? 'true' : 'false'); }

    function focusables() {
      return Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getClientRects().length > 0; }
      );
    }

    function onKey(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab' || !isModal()) return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (!panel.contains(active)) {
        event.preventDefault();
        first.focus();
      } else if (event.shiftKey && (active === first || active === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      stopWatching();
      isOpen = true;
      setModal();
      root.hidden = false;
      root.classList.add('is-open');
      document.addEventListener('keydown', onKey);
      // Being shown counts as seen, so the card doesn't follow people from
      // page to page if they scroll past it without closing it.
      if (!design && !forced && load().state !== 'subscribed') save({ state: 'seen', at: Date.now() });
      // On computers it's a modal window, so focus moves into it. On phones
      // it's a card at the bottom of the page, so focus stays where it is.
      if (isModal()) {
        lastFocus = document.activeElement;
        panel.focus({ preventScroll: true });
      }
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      root.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (!design && !forced && load().state !== 'subscribed') save({ state: 'closed', at: Date.now() });
      if (lastFocus && typeof lastFocus.focus === 'function' && document.contains(lastFocus)) {
        lastFocus.focus({ preventScroll: true });
      }
      lastFocus = null;
    }

    function showDone(moveFocus) {
      stepForm.hidden = true;
      stepDone.hidden = false;
      panel.setAttribute('aria-labelledby', doneTitle.id);
      if (moveFocus) doneTitle.focus({ preventScroll: true });
    }

    function showError(message) {
      error.textContent = message;
      error.hidden = false;
      input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      error.hidden = true;
      error.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    function setBusy(busy) {
      submit.disabled = busy;
      if (busy) {
        submit.setAttribute('aria-busy', 'true');
        submit.textContent = 'Signing up…';
      } else {
        submit.removeAttribute('aria-busy');
        submit.textContent = submit.dataset.label;
      }
    }

    input.addEventListener('input', function () {
      if (!error.hidden) clearError();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var email = input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        showError('Enter a valid email address, like name@example.com.');
        input.focus();
        return;
      }
      if (!key || !list) {
        showError('This form isn’t connected to Klaviyo yet. Add the list ID in the theme editor.');
        return;
      }
      clearError();
      setBusy(true);
      window.fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website popup',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (response) {
        if (!response.ok) {
          var failure = new Error('Klaviyo ' + response.status);
          failure.status = response.status;
          throw failure;
        }
        save({ state: 'subscribed', at: Date.now() });
        try {
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: email });
        } catch (e) { /* tracking only */ }
        setBusy(false);
        showDone(true);
      }).catch(function (failure) {
        setBusy(false);
        showError(failure && failure.status === 400
          ? 'Klaviyo couldn’t accept that email address. Check it and try again.'
          : 'We couldn’t sign you up just now. Check your connection and try again.');
        input.focus();
      });
    });

    if (copy && code) {
      copy.addEventListener('click', function () {
        var text = code.textContent.trim();
        function selectCode() {
          var range = document.createRange();
          range.selectNodeContents(code);
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
        function copied() {
          copy.textContent = 'Copied';
          window.setTimeout(function () { copy.textContent = 'Copy code'; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(copied, selectCode);
        } else {
          selectCode();
        }
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-sm-popup-close]'), function (el) {
      el.addEventListener('click', function () { close(); });
    });

    var onViewport = function () { if (isOpen) setModal(); };
    if (desktop.addEventListener) desktop.addEventListener('change', onViewport);

    // ---- When it opens --------------------------------------------------------
    var checking = false;
    function trigger() {
      if (isOpen || checking) return;
      // Wait while the cart, menu or search drawer is open
      if (/\boverflow-hidden/.test(document.body.className)) {
        window.clearTimeout(timer);
        timer = window.setTimeout(trigger, 4000);
        return;
      }
      checking = true;
      klaviyoKnows(function (known) {
        checking = false;
        if (known) {
          stopWatching();
          return;
        }
        open();
      });
    }

    function onScroll() {
      var room = document.documentElement.scrollHeight - window.innerHeight;
      if (room > 0 && window.scrollY / room >= scrollPct / 100) trigger();
    }

    function stopWatching() {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    }

    function watch() {
      timer = window.setTimeout(trigger, delay * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    root.smOpen = open;

    if (design) {
      if (root.hasAttribute('data-preview-success')) showDone(false);
      return;
    }
    if (forced) {
      open();
      return;
    }
    var state = load();
    var waiting = state.state === 'subscribed' ||
      ((state.state === 'seen' || state.state === 'closed') && Date.now() - (Number(state.at) || 0) < days * DAY);
    if (!waiting && key && list && !klaviyoCookieKnows()) watch();
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-sm-popup]'), init);

  // Theme editor: open the popup while its section is selected
  function sectionRoot(event) {
    var id = event.detail && event.detail.sectionId;
    return id ? document.querySelector('[data-sm-popup][data-section="' + id + '"]') : null;
  }
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sm-popup]');
    if (!root) return;
    init(root);
    if (root.smOpen) root.smOpen();
  });
  document.addEventListener('shopify:section:select', function (event) {
    var root = sectionRoot(event);
    if (root && root.smOpen) root.smOpen();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var root = sectionRoot(event);
    if (root) {
      var closer = root.querySelector('.sm-popup__close');
      if (closer && !root.hidden) closer.click();
    }
  });
})();